import { CanActivateFn } from '@angular/router';
import { keycloak } from './keycloak';

export function roleGuard(roles: string[]): CanActivateFn {
  return () => {
    if (!roles || roles.length === 0) return true;
    return roles.some((r) => keycloak.hasRealmRole(r));
  };
}
